import React, {useState, useEffect} from 'react'
import {AlertDialog} from '../../../components/Dialog/Dialog'
import {
  formatRut,
  validateRut as validaRut,
  validarEmail,
  validarTelefono,
} from '../../../Functions'
import {
  sendCodeIdentity,
  verifyCodeIdentity,
  verifyRutApi,
  createSolicitud,
  getBanks,
  consultarSolicitud,
  respoderSolicitud,
  getCiudades,
  getComunas,
  getRegiones,
} from '../core/_requests'

export const Solicitud = () => {
  const [archivos, setArchivos] = useState([])
  const [infoAdicional, setInfoAdicional] = useState('')

  const handleArchivoChange = (index, event) => {
    const updatedArchivos = [...archivos]
    updatedArchivos[index] = {
      ...updatedArchivos[index],
      archivo: event.target.files[0],
    }
    setArchivos(updatedArchivos)
  }

  const handleTipoDocumentoChange = (index, event) => {
    const updatedArchivos = [...archivos]
    updatedArchivos[index] = {
      ...updatedArchivos[index],
      tipo: event.target.value,
    }
    setArchivos(updatedArchivos)
  }

  const agregarArchivo = () => {
    setArchivos([...archivos, {archivo: null, tipo: ''}])
  }
  const enviarDocumentos = async () => {
    setLoading(true)
    setError('')

    try {
      const datos = {
        id_solicitud: dataSolicitud.Codigo,
        archivos,
        info_adicional: infoAdicional,
      }

      // Llamar a la API y dejar que ella formatee los datos
      const {data} = await respoderSolicitud(datos)

      if (data.status) {
        setMessageAlertError('Documentos enviados correctamente.')
        setShowAlertError(true)
        setRequestType('')
        setConsultaData({rut: '', codigo: '', verificado: false})
        setArchivos([])
        setInfoAdicional('')
      } else {
        setError('Error al enviar los documentos. Intente nuevamente.')
      }
    } catch (error) {
      setError('Hubo un error inesperado. Intente nuevamente.')
    } finally {
      setLoading(false)
    }
  }

  const [requestType, setRequestType] = useState('')
  const [currentStep, setCurrentStep] = useState(1)
  const [selectedMethod, setSelectedMethod] = useState(null)
  const [showVerificationInput, setShowVerificationInput] = useState(false)
  const [tempVerificationCode, setTempVerificationCode] = useState('')
  const [verificationStatus, setVerificationStatus] = useState({
    email: false,
    phone: false,
  })
  const [messageAlertError, setMessageAlertError] = useState('')
  const [showAlertError, setShowAlertError] = useState(false)
  const [validErrorRut, setErrorRut] = useState(false)
  const [showError, setShowError] = useState(false)
  const [consultaData, setConsultaData] = useState({
    rut: '',
    codigo: '',
    verificado: false,
  })

  const STEP_VERIFICACION_RUT = 1
  const STEP_VALIDACION_DATOS = 2
  const STEP_DATOS_PERSONALES = 3
  const STEP_TIPO_CONTRATO = 4
  const STEP_DOCUMENTACION = 5
  const STEP_FINAL = 6

  const initialSteps = [
    {
      id: STEP_VERIFICACION_RUT,
      title: 'Verificación RUT',
      description: 'Ingrese su RUT para verificar su acceso',
    },
    {
      id: STEP_VALIDACION_DATOS,
      title: 'Validación de Datos',
      description: 'Confirme sus datos de contacto',
    },
  ]

  const additionalSteps = [
    {
      id: STEP_DATOS_PERSONALES,
      title: 'Datos Personales',
      description: 'Verifique e ingrese sus datos personales',
    },
    {
      id: STEP_TIPO_CONTRATO,
      title: 'Tipo de Contrato',
      description: 'Seleccione el tipo de contrato y forma de pago',
    },
    {
      id: STEP_DOCUMENTACION,
      title: 'Documentación',
      description: 'Cargue los documentos requeridos',
    },
    {
      id: STEP_FINAL,
      title: 'Finalización',
      description: 'Verificación de datos y finalización de la solicitud',
    },
  ]

  const [steps, setSteps] = useState(initialSteps)

  const initialState = {
    rut: '',
    userData: {
      rut: '',
      name: '',
      email: '',
      phone: '',
      celular: '',
      medico: '',
      staff: '',
      banco: '',
      comuna: '',
      ciudad: '',
      region: '',
      direccion: '',
      cuenta: '',
      profesion: '',
      especialidad: '',
      nacionalidad: ''
    },
    memberType: '',
    hmqPaymentType: '',
    consultaPaymentType: '',
    societyHmq: {
      name: '',
      rut: '',
      bank: '',
      accountNumber: '',
      isLegalRepresentative: '',
      direccion: '',
      comuna: '',
      email: '',
      categoria: '',
      representative: {
        rut: '',
        name: '',
        email: '',
        phone: '',
        nacionalidad: '',
        profesion: '',
        direccion: '',
        comuna: '',
        region: '',
      },
    },
    societyConsultas: {
      name: '',
      rut: '',
      bank: '',
      accountNumber: '',
      isLegalRepresentative: '',
      direccion: '',
      comuna: '',
      email: '',
      categoria: '',
      representative: {
        rut: '',
        name: '',
        email: '',
        phone: '',
        nacionalidad: '',
        profesion: '',
        direccion: '',
        comuna: '',
        region: '',
      },
    },
    documents: {
      idFront: null,
      idBack: null,
      societyDocsHmq: null,
      societyDocsConsultas: null,
    },
  }
  const [formData, setFormData] = useState(initialState)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [mockBanks, setMockBanks] = useState([])
  const [ciudades, setCiudades] = useState([])
  const [comunas, setComunas] = useState([])
  const [regiones, setRegiones] = useState([])

  const _getBanks = async () => {
    const {data} = await getBanks()
    if (data.status) {
      setMockBanks(data.bancos)
    }
  }

  const _getCiudades = async () => {
    const {data} = await getCiudades()
    if (data.status) {
      setCiudades(data.ciudades)
    }
  }

  const _getComunas = async () => {
    const {data} = await getComunas()
    if (data.status) {
      setComunas(data.comunas)
    }
  }

  const _getRegiones = async () => {
    const {data} = await getRegiones()
    if (data.status) {
      setRegiones(data.regiones)
    }
  }

  const [dataSolicitud, setDataSolicitud] = useState(null)

  const validateRut = async (rut) => {
    setLoading(true)
    try {
      const {data} = await verifyRutApi(formData.rut)
      if (data.status) {
        setFormData((prev) => ({
          ...prev,
          userData: data?.profesional,
          memberType:
            Number(data?.profesional?.staff) === 1 && data?.profesional?.medico === 'S'
              ? 'socio'
              : 'mandante',
        }))
        setError('')
        setCurrentStep(STEP_VALIDACION_DATOS)
        return true
      } else {
        setError(
          'No cumple con los requisitos necesarios. Por favor comuníquese con RRMM (telefónica o presencialmente)'
        )
        return false
      }
    } finally {
      setLoading(false)
    }
  }

  const verifyCode = async (type, code) => {
    setLoading(true)
    try {
      const {data} = await verifyCodeIdentity(type, code, formData.rut)
      if (data.status) {
        setVerificationStatus((prev) => ({...prev, [type]: true}))
        setSteps([...initialSteps, ...additionalSteps])
        setError('')
        setCurrentStep((prev) => prev + 1)
        return true
      }
      setError(
        'Código de verificación inválido. Por favor verifique e intente nuevamente o comuníquese con relaciones médicas para mayor información.'
      )
      return false
    } finally {
      setLoading(false)
    }
  }

  const sendVerificationCode = async (type) => {
    setLoading(true)
    try {
      const {data} = await sendCodeIdentity(type, formData.rut)
      if (data.status) {
        setMessageAlertError(
          `Código de verificación enviado al ${type === 'email' ? 'correo' : 'teléfono'}`
        )
        //setShowAlertError(true);
        setShowVerificationInput(true)
      } else {
        setError(
          'Código no enviado!!! Por favor verifique e intente nuevamente o comuníquese con relaciones médicas para mayor información.'
        )
        return false
      }
    } finally {
      setLoading(false)
    }
  }

  const validateConsultaData = async () => {
    setLoading(true)
    try {
      const {data} = await consultarSolicitud(consultaData.codigo, consultaData.rut)
      if (data.status) {
        setDataSolicitud(data.solicitud)
        setError('')
        setConsultaData((prev) => ({...prev, verificado: true}))
      } else {
        setError('RUT o código de verificación incorrectos')
        return false
      }
    } finally {
      setLoading(false)
    }
  }

  const finalizarSolicitud = async () => {
    // Validar RUT del representante legal si es sociedad y no es representante legal
    if (
      formData.hmqPaymentType === 'sociedad' &&
      formData.societyHmq.isLegalRepresentative === 'false'
    ) {
      if (!validaRut(formData.societyHmq.representative.rut)) {
        setError('RUT del representante legal de HMQ es inválido.')
        setShowError(true)
        return false
      }

      if (!validarEmail(formData.societyHmq.representative.email)) {
        setError('Email del representante legal de HMQ es inválido.')
        setShowError(true)
        return false
      }

      if (!validarTelefono(formData.societyHmq.representative.phone)) {
        setError(
          'Teléfono del representante legal de HMQ es inválido. Debe tener el formato +569XXXXXXXX.'
        )
        setShowError(true)
        return false
      }
    }

    if (
      formData.consultaPaymentType === 'sociedad' &&
      formData.societyConsultas.isLegalRepresentative === 'false'
    ) {
      if (!validaRut(formData.societyConsultas.representative.rut)) {
        setError('RUT del representante legal de Consultas es inválido.')
        setShowError(true)
        return false
      }
      if (!validarEmail(formData.societyConsultas.representative.email)) {
        setError('Email del representante legal de Consultas es inválido.')
        setShowError(true)
        return false
      }
      if (!validarTelefono(formData.societyConsultas.representative.phone)) {
        setError(
          'Teléfono del representante legal de Consultas es inválido. Debe tener el formato +569XXXXXXXX.'
        )
        setShowError(true)
        return false
      }
    }

    setLoading(true)
    setError('')
    try {
      const {data} = await createSolicitud(formData)
      if (data.status) {
        const codigoSolicitud = data.codigoSolicitud
        setMessageAlertError(
          `Su código de solicitud es: ${codigoSolicitud}. Por favor guárdelo para consultas futuras.`
        )
        setShowAlertError(true)
        setCurrentStep((prev) => prev + 1)
      } else {
        setError(
          'Error al crear la solicitud. Por favor intente nuevamente o comuníquese con relaciones médicas para mayor información.'
        )
        return false
      }
    } finally {
      setLoading(false)
    }
  }

  const handleChangeHmq = (value) => {
    if (value === 'natural') {
      setFormData({
        ...formData,
        hmqPaymentType: value,
        societyHmq: {
          ...formData.societyHmq,
          rut: '',
          name: '',
          direccion: '',
          comuna: '',
          email: '',
          bank: '',
          accountNumber: '',
          categoria: ''
        },
      })
    } else {
      setFormData({...formData, hmqPaymentType: value})
    }
  }

  const handleChangeConsultas = (value) => {
    if (
        value === 'sociedad' &&
        formData.societyConsultas.rut.length === 0 &&
        formData.societyConsultas.name.length === 0
      ) {
        setFormData({
          ...formData,
          consultaPaymentType: value,
          societyConsultas: {
            ...formData.societyConsultas,
            rut: formData.societyHmq.rut,
            name: formData.societyHmq.name,
            direccion: formData.societyHmq.direccion,
            comuna: formData.societyHmq.comuna,
            bank: formData.societyHmq.bank,
            email: formData.societyHmq.email,
            accountNumber: formData.societyHmq.accountNumber,
            categoria: formData.societyHmq.categoria
          },
        })
      } else if (value === 'natural') {
        setFormData({
          ...formData,
          consultaPaymentType: value,
          societyConsultas: {
            ...formData.societyConsultas,
            rut: '',
            name: '',
            direccion: '',
            comuna: '',
            bank: '',
            email: '',
            accountNumber: '',
            categoria: ''
          },
        })
      } else {
        setFormData({...formData, consultaPaymentType: value})
      }
  }

  const canProceed = () => {
    switch (currentStep) {
      case STEP_VERIFICACION_RUT:
        return formData.rut.length > 0
      case STEP_VALIDACION_DATOS:
        if (!selectedMethod) return false
        if (!showVerificationInput && selectedMethod) {
          return true // Permite avanzar para mostrar el input
        }
        if (showVerificationInput) {
          return tempVerificationCode.length === 6
        }
        return verificationStatus[selectedMethod]
      case STEP_DATOS_PERSONALES:
        if (!formData.userData) return false
        if (
          !formData.userData.direccion ||
          !formData.userData.comuna ||
          !formData.userData.ciudad ||
          !formData.userData.region ||
          !formData.userData.banco ||
          !formData.userData.cuenta ||
          !formData.userData.nacionalidad ||
          !validarTelefono(formData.userData.celular)
        )
          return false
        return true
      case STEP_TIPO_CONTRATO:
        if (
          !formData.memberType ||
          !formData.hmqPaymentType ||
          !formData.consultaPaymentType ||
          (formData.hmqPaymentType === 'sociedad' &&
            (!formData.societyHmq.rut ||
              !formData.societyHmq.name ||
              !validaRut(formData.societyHmq.rut) ||
              !formData.societyHmq.direccion ||
              !formData.societyHmq.categoria ||
              !formData.societyHmq.comuna)) ||
          (formData.consultaPaymentType === 'sociedad' &&
            (!formData.societyConsultas.rut ||
              !formData.societyConsultas.name ||
              !validaRut(formData.societyConsultas.rut) ||
              !formData.societyConsultas.direccion ||
              !formData.societyConsultas.categoria ||
              !formData.societyConsultas.comuna)) ||
          (formData.hmqPaymentType === 'sociedad' &&
            (!formData.societyHmq.bank || !formData.societyHmq.accountNumber)) ||
          (formData.consultaPaymentType === 'sociedad' &&
            (!formData.societyConsultas.bank || !formData.societyConsultas.accountNumber))
        )
          return false
        return true
      case STEP_DOCUMENTACION:
        if (!formData.documents.idFront || !formData.documents.idBack) return false
        if (formData.hmqPaymentType === 'sociedad') {
          if (!formData.documents.societyDocsHmq || !formData.societyHmq.isLegalRepresentative)
            return false
          if (formData.societyHmq.isLegalRepresentative === 'false') {
            const rep = formData.societyHmq.representative
            if (!rep.rut || !rep.name || !rep.email || !rep.phone) return false
          }
        }
        if (formData.consultaPaymentType === 'sociedad') {
          if (
            (!formData.documents.societyDocsConsultas &&
              formData.societyHmq.rut !== formData.societyConsultas.rut) ||
            !formData.societyConsultas.isLegalRepresentative
          )
            return false
          if (formData.societyConsultas.isLegalRepresentative === 'false') {
            const rep = formData.societyConsultas.representative
            if (!rep.rut || !rep.name || !rep.email || !rep.phone) return false
          }
        }
        return true
      default:
        return true
    }
  }

  const renderConsultaView = () => (
    <div>
      {!consultaData.verificado ? (
        <div className='row g-3'>
          <div className='col-12'>
            <label className='form-label'>RUT</label>
            <input
              type='text'
              className='form-control'
              placeholder='Ingrese su RUT'
              value={consultaData.rut}
              onChange={(e) => {
                const formattedRut = formatRut(e.target.value)
                setConsultaData({...consultaData, rut: formattedRut})
              }}
            />
          </div>
          <div className='col-12'>
            <label className='form-label'>Código de Verificación</label>
            <input
              type='text'
              className='form-control'
              placeholder='Ingrese el código de su solicitud'
              value={consultaData.codigo}
              onChange={(e) => setConsultaData({...consultaData, codigo: e.target.value})}
            />
          </div>
          <div className='d-flex justify-content-between'>
            <button
              className='btn btn-light'
              onClick={() => {
                setRequestType('')
                setConsultaData({rut: '', codigo: '', verificado: false})
              }}
            >
              Volver
            </button>
            <button className='btn btn-primary' onClick={validateConsultaData} disabled={loading}>
              {loading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2'></span> Procesando...
                </>
              ) : (
                'Verificar'
              )}
            </button>
          </div>
        </div>
      ) : (
        <div>
          <div className='table-responsive'>
            <table className='table table-hover'>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Fecha</th>
                  <th>Estado</th>
                  <th>Tipo</th>
                  <th>Última Actualización</th>
                </tr>
              </thead>
              <tbody>
                {dataSolicitud && (
                  <tr>
                    <td>{dataSolicitud.Codigo}</td>
                    <td>{dataSolicitud.created_at}</td>
                    <td>
                      <span
                        className={`badge ${
                          dataSolicitud.Estado == '-1'
                            ? 'bg-danger text-white'
                            : dataSolicitud.Estado == '7'
                            ? 'bg-success'
                            : 'bg-secondary'
                        }`}
                      >
                        {dataSolicitud.Estado == '-1'
                          ? 'Devuelta'
                          : dataSolicitud.Estado == '7'
                          ? 'Finalizada'
                          : 'Pendiente'}
                      </span>
                    </td>
                    <td>{dataSolicitud.Tipo_Contrato == 1 ? 'Socio' : 'Mandante'}</td>
                    <td>{dataSolicitud.updated_at}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {dataSolicitud.Estado == '-1' && (
            <div className='alert alert-danger mt-3'>
              <strong>Razón de devolución:</strong> {dataSolicitud.Devolucion_Profesional}
            </div>
          )}

          {dataSolicitud.Estado == '-1' && (
            <div className='mt-4'>
              <h5>Subir documentos</h5>
              {archivos.map((archivo, index) => (
                <div key={index} className='d-flex align-items-center mb-2'>
                  <input
                    type='file'
                    accept='.pdf,.doc,.docx,.jpg,.jpeg,.png,.gif'
                    className='form-control'
                    onChange={(e) => handleArchivoChange(index, e)}
                  />
                  <select
                    className='form-select mx-2'
                    onChange={(e) => handleTipoDocumentoChange(index, e)}
                    value={archivo.tipo}
                  >
                    <option value=''>Seleccione tipo</option>
                    <option value='cedula_frontal'>Cédula Frontal</option>
                    <option value='cedula_reverso'>Cédula Reverso</option>
                    <option value='escritura'>Escritura de Sociedad</option>
                    <option value='otro'>Otro</option>
                  </select>
                </div>
              ))}
              <button className='btn btn-primary btn-sm mt-2' onClick={agregarArchivo}>
                Agregar otro archivo
              </button>

              <div className='mt-3'>
                <label>Información adicional:</label>
                <textarea
                  className='form-control'
                  rows='3'
                  value={infoAdicional}
                  onChange={(e) => setInfoAdicional(e.target.value)}
                />
              </div>

              <button className='btn btn-success btn-sm mt-3' onClick={enviarDocumentos}>
                Responder Solicitud
              </button>
            </div>
          )}

          <button
            className='btn btn-light mt-3'
            onClick={() => {
              setConsultaData({rut: '', codigo: '', verificado: false})
              setRequestType('')
            }}
          >
            Volver
          </button>
        </div>
      )}
    </div>
  )

  const renderStep = () => {
    switch (currentStep) {
      case STEP_VERIFICACION_RUT:
        return (
          <div className='mb-3'>
            <label className='form-label'>RUT Profesional</label>
            <input
              type='text'
              className={`form-control ${
                formData.rut.length >= 1 ? (validErrorRut ? 'is-invalid' : 'is-valid') : ''
              }`}
              placeholder='Ingrese su RUT'
              value={formData.rut}
              onChange={async (e) => {
                const formattedRut = await formatRut(e.target.value)
                setFormData({...formData, rut: formattedRut})
                const valid = validaRut(formattedRut)
                if (!valid) {
                  setErrorRut(true)
                } else {
                  setErrorRut(false)
                }
              }}
            />
            {formData.rut.length >= 1 && validErrorRut && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>RUT inválido</span>
                </div>
              </div>
            )}
          </div>
        )
      case STEP_VALIDACION_DATOS:
        return (
          <div className='mb-3'>
            {formData.userData && (
              <>
                <p className='text-gray-600 fs-7 mb-3'>
                  <i className='fas fa-info-circle me-1'></i>
                  Si sus datos de contacto no son correctos o necesita actualizar su información,
                  por favor comuníquese con nuestro equipo de soporte a
                  <a href='mailto:informaciones@amsm.cl' className='ms-1'>
                    informaciones@amsm.cl
                  </a>{' '}
                  para recibir asistencia personalizada.
                </p>

                {!showVerificationInput ? (
                  <>
                    <p className='mb-3 fw-semibold'>
                      Seleccione dónde desea recibir el código de verificación:
                    </p>

                    <div
                      className='card mb-3'
                      onClick={() => setSelectedMethod('email')}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: selectedMethod === 'email' ? '#f8f9fa' : 'white',
                      }}
                    >
                      <div className='card-body'>
                        <div className='d-flex align-items-center'>
                          <input
                            type='radio'
                            checked={selectedMethod === 'email'}
                            onChange={() => setSelectedMethod('email')}
                            className='me-3'
                          />
                          <div>
                            <div>
                              <i className='fas fa-envelope me-2'></i>Correo electrónico
                            </div>
                            <div className='text-muted small'>{formData.userData.email}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {formData.userData.phone && (
                      <div
                        className='card mb-3'
                        onClick={() => setSelectedMethod('phone')}
                        style={{
                          cursor: 'pointer',
                          backgroundColor: selectedMethod === 'phone' ? '#f8f9fa' : 'white',
                        }}
                      >
                        <div className='card-body'>
                          <div className='d-flex align-items-center'>
                            <input
                              type='radio'
                              checked={selectedMethod === 'phone'}
                              onChange={() => setSelectedMethod('phone')}
                              className='me-3'
                            />
                            <div>
                              <div>
                                <i className='fas fa-mobile-alt me-2'></i>Teléfono móvil
                              </div>
                              <div className='text-muted small'>{formData.userData.phone}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {selectedMethod && (
                      <div className='alert alert-primary mb-3'>
                        <i className='fas fa-info-circle me-2'></i>
                        Al presionar siguiente, se enviará un código de verificación al{' '}
                        {selectedMethod === 'email' ? 'correo electrónico' : 'teléfono móvil'}{' '}
                        seleccionado.
                      </div>
                    )}
                  </>
                ) : (
                  <div className='mb-3'>
                    <div className='alert alert-primary mb-3'>
                      <i className='fas fa-info-circle me-2'></i>
                      Se ha enviado un código de verificación a su{' '}
                      {selectedMethod === 'email' ? 'correo electrónico' : 'teléfono móvil'}. Por
                      favor, ingréselo a continuación.
                    </div>
                    <label className='form-label'>
                      Código de verificación {selectedMethod === 'email' ? 'email' : 'SMS'}
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      placeholder={`Ingrese el código de verificación`}
                      onChange={(e) => setTempVerificationCode(e.target.value)}
                      value={tempVerificationCode}
                      disabled={verificationStatus[selectedMethod]}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        )
      case STEP_DATOS_PERSONALES:
        return (
          <div className='mb-3'>
            {formData.userData && (
              <>
                <p className='text-gray-600 fs-7 mb-3'>
                  <i className='fas fa-info-circle me-1'></i>
                  Por favor, revise y actualice los datos a continuación si es necesario.
                </p>

                {/* Datos del profesional */}
                <div className='row'>
                  <div className='mb-3 col-md-4'>
                    <p className='fw-semibold'>Rut Profesional</p>
                    <input
                      type='text'
                      className='form-control'
                      value={formData.userData.rut}
                      disabled
                    />
                  </div>

                  <div className='mb-3 col-md-8'>
                    <p className='fw-semibold'>Nombre del Profesional</p>
                    <input
                      type='text'
                      className='form-control'
                      value={formData.userData.name}
                      disabled
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='mb-3 col-md-4'>
                    <p className='fw-semibold'>Profesión</p>
                    <input
                      type='text'
                      className='form-control'
                      value={formData.userData.profesion}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, profesion: e.target.value || ''},
                        })
                      }
                    />
                  </div>

                  <div className='mb-3 col-md-4'>
                    <p className='fw-semibold'>Especialidad</p>
                    <input
                      type='text'
                      className='form-control'
                      value={formData.userData.especialidad}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, especialidad: e.target.value || ''},
                        })
                      }
                    />
                  </div>
                  <div className='mb-3 col-md-4'>
                    <p className='fw-semibold'>Nacionalidad</p>
                    <input
                      type='text'
                      className='form-control'
                      value={formData.userData.nacionalidad}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, nacionalidad: e.target.value || ''},
                        })
                      }
                    />
                  </div>
                </div>

                <div className='row'>
                  {/* Dirección */}
                  <div className='mb-3 col-md-8'>
                    <p className='fw-semibold'>Dirección</p>
                    <input
                      type='text'
                      className='form-control'
                      value={formData.userData.direccion}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, direccion: e.target.value},
                        })
                      }
                    />
                  </div>
                  <div className='mb-3 col-md-4'>
                    <p className='fw-semibold'>Teléfono Celular</p>
                    <input
                      type='text'
                      className={`form-control ${
                        formData.userData.celular && !validarTelefono(formData.userData.celular)
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={formData.userData.celular}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, celular: e.target.value},
                        })
                      }
                    />
                    {formData.userData.celular && !validarTelefono(formData.userData.celular) && (
                      <div className='invalid-feedback'>
                        El número debe tener el formato +569XXXXXXXX.
                      </div>
                    )}
                  </div>
                </div>

                <div className='row'>
                  {/* Comuna */}
                  <div className='mb-3 col-md-4'>
                    <p className='fw-semibold'>Comuna</p>
                    <select
                      className='form-select'
                      value={formData.userData.comuna}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, comuna: e.target.value},
                        })
                      }
                    >
                      <option value=''>Seleccione una comuna</option>
                      {comunas.map((comuna) => (
                        <option key={comuna.id} value={comuna.id}>
                          {comuna.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Ciudad */}
                  <div className='mb-3 col-md-4'>
                    <p className='fw-semibold'>Ciudad</p>
                    <select
                      className='form-select'
                      value={formData.userData.ciudad}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, ciudad: e.target.value},
                        })
                      }
                    >
                      <option value=''>Seleccione una ciudad</option>
                      {ciudades.map((ciudad) => (
                        <option key={ciudad.id} value={ciudad.id}>
                          {ciudad.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Región */}
                  <div className='mb-3 col-md-4'>
                    <p className='fw-semibold'>Región</p>
                    <select
                      className='form-select'
                      value={formData.userData.region}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, region: e.target.value},
                        })
                      }
                    >
                      <option value=''>Seleccione una región</option>
                      {regiones.map((region) => (
                        <option key={region.id} value={region.id}>
                          {region.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='row'>
                  {/* Datos de la cuenta personal */}
                  <div className='mb-3 col-md-6'>
                    <p className='fw-semibold'>Banco Cuenta Personal</p>
                    <select
                      className='form-select'
                      value={formData.userData.banco}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, banco: e.target.value},
                        })
                      }
                    >
                      <option value=''>Seleccione banco</option>
                      {mockBanks.map((bank) => (
                        <option key={bank.id} value={bank.id}>
                          {bank.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className='mb-3 col-md-6'>
                    <p className='fw-semibold'>Número de Cuenta Personal</p>
                    <input
                      type='text'
                      className='form-control'
                      value={formData.userData.cuenta}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          userData: {...formData.userData, cuenta: e.target.value},
                        })
                      }
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        )
      case STEP_TIPO_CONTRATO:
        return (
          <div>
            <div className='mb-3'>
              <label className='form-label'>Tipo de Contrato</label>
              <select
                className='form-select'
                value={formData.memberType}
                onChange={(e) => setFormData({...formData, memberType: e.target.value})}
              >
                <option value=''>Seleccione tipo</option>
                {Number(formData?.userData?.staff) === 1 && formData?.userData?.medico === 'S' && (
                  <option value='socio'>Socio</option>
                )}
                <option value='mandante'>Mandante</option>
              </select>
            </div>

            {formData.memberType === 'socio' && (
              <div className='alert alert-primary mb-3'>
                <strong>Importante:</strong> Su solicitud quedará pendiente hasta que envíe el
                comprobante de transferencia por UF 20 a AMSM. Se le enviará un correo con los
                detalles para realizar el pago.
              </div>
            )}

            <div className='alert alert-primary mb-3'>
              <i className='fas fa-info-circle me-1'></i>
              Seleccione la razón social para sus pagos de Honorarios Médicos Quirúrgicos (HMQ) y/o
              Consultas Ambulatorias.
            </div>
            <div className='card'>
              <div className='card-body' style={{paddingInline: '10px', paddingBlock: '10px'}}>
                <div className='mb-3'>
                  <label className='form-label'>HMQ</label>
                  <select
                    className='form-select'
                    value={formData.hmqPaymentType}
                    onChange={(e) => handleChangeHmq(e.target.value)}
                  >
                    <option value=''>Seleccione tipo de pago</option>
                    <option value='natural'>Persona Natural</option>
                    <option value='sociedad'>Sociedad</option>
                  </select>
                </div>

                {formData.hmqPaymentType === 'sociedad' && (
                  <>
                    <div className='row'>
                      <div className='col-md-4 mb-3'>
                        <label className='form-label'>RUT Sociedad</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ingrese RUT de la sociedad'
                          value={formData.societyHmq.rut}
                          onChange={async (e) => {
                            const formattedRut = await formatRut(e.target.value)
                            setFormData({
                              ...formData,
                              societyHmq: {...formData.societyHmq, rut: formattedRut},
                            })
                          }}
                        />
                      </div>
                      <div className='col-md-8 mb-3'>
                        <label className='form-label'>Nombre Sociedad</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ingrese nombre de la sociedad'
                          value={formData.societyHmq.name}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyHmq: {...formData.societyHmq, name: e.target.value},
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-6 mb-3'>
                        <label className='form-label'>Dirección Sociedad</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ingrese dirección de la sociedad'
                          value={formData.societyHmq.direccion}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyHmq: {...formData.societyHmq, direccion: e.target.value},
                            })
                          }
                        />
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Comuna Sociedad</label>
                        <select
                          className='form-select'
                          value={formData.societyHmq.comuna}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyHmq: {...formData.societyHmq, comuna: e.target.value},
                            })
                          }
                        >
                          <option value=''>Seleccione una comuna</option>
                          {comunas.map((comuna) => (
                            <option key={comuna.id} value={comuna.id}>
                              {comuna.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Categoria Trib. Sociedad</label>
                        <select
                          className='form-select'
                          value={formData.societyHmq.categoria}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyHmq: {...formData.societyHmq, categoria: e.target.value},
                            })
                          }
                        >
                          <option value=''>Seleccione categoría</option>
                          <option value='PRIMERA CATEGORÍA'>PRIMERA CATEGORÍA</option>
                          <option value='SEGUNDA CATEGORÍA'>SEGUNDA CATEGORÍA</option>
                        </select>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-6 mb-3'>
                        <label className='form-label'>Banco</label>
                        <select
                          className='form-select'
                          value={formData.societyHmq.bank}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyHmq: {
                                ...formData.societyHmq,
                                bank: e.target.value,
                              },
                            })
                          }
                        >
                          <option value=''>Seleccione banco</option>
                          {mockBanks.map((bank) => (
                            <option key={bank.id} value={bank.id}>
                              {bank.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Número de Cuenta</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ingrese número de cuenta para HMQ'
                          value={formData.societyHmq.accountNumber}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyHmq: {
                                ...formData.societyHmq,
                                accountNumber: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Email Sociedad</label>
                        <input
                          type='email'
                          className='form-control'
                          placeholder='Ingrese email de la sociedad'
                          value={formData.societyHmq.email}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyHmq: {...formData.societyHmq, email: e.target.value},
                            })
                          }
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className='card' style={{borderTop: '1px solid #e9ecef'}}>
              <div className='card-body' style={{paddingInline: '10px', paddingBlock: '10px'}}>
                <div className='mb-3'>
                  <label className='form-label'>Consultas</label>
                  <select
                    className='form-select'
                    value={formData.consultaPaymentType}
                    onChange={(e) => handleChangeConsultas(e.target.value)}
                  >
                    <option value=''>Seleccione tipo de pago</option>
                    <option value='natural'>Persona Natural</option>
                    <option value='sociedad'>Sociedad</option>
                  </select>
                </div>

                {formData.consultaPaymentType === 'sociedad' && (
                  <>
                    <div className='row'>
                      <div className='col-md-4 mb-3'>
                        <label className='form-label'>RUT Sociedad</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ingrese RUT de la sociedad'
                          value={formData.societyConsultas.rut}
                          onChange={async (e) => {
                            const formattedRut = await formatRut(e.target.value)
                            setFormData({
                              ...formData,
                              societyConsultas: {...formData.societyConsultas, rut: formattedRut},
                            })
                          }}
                        />
                      </div>
                      <div className='col-md-8 mb-3'>
                        <label className='form-label'>Nombre Sociedad</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ingrese nombre de la sociedad'
                          value={formData.societyConsultas.name}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyConsultas: {
                                ...formData.societyConsultas,
                                name: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-6 mb-3'>
                        <label className='form-label'>Dirección Sociedad</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ingrese dirección de la sociedad'
                          value={formData.societyConsultas.direccion}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyConsultas: {
                                ...formData.societyConsultas,
                                direccion: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Comuna Sociedad</label>
                        <select
                          className='form-select'
                          value={formData.societyConsultas.comuna}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyConsultas: {
                                ...formData.societyConsultas,
                                comuna: e.target.value,
                              },
                            })
                          }
                        >
                          <option value=''>Seleccione una comuna</option>
                          {comunas.map((comuna) => (
                            <option key={comuna.id} value={comuna.id}>
                              {comuna.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Categoria Trib. Sociedad</label>
                        <select
                          className='form-select'
                          value={formData.societyConsultas.categoria}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyConsultas: {
                                ...formData.societyConsultas,
                                categoria: e.target.value,
                              },
                            })
                          }
                        >
                          <option value=''>Seleccione categoría</option>
                          <option value='PRIMERA CATEGORÍA'>PRIMERA CATEGORÍA</option>
                          <option value='SEGUNDA CATEGORÍA'>SEGUNDA CATEGORÍA</option>
                        </select>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-6 mb-3'>
                        <label className='form-label'>Banco</label>
                        <select
                          className='form-select'
                          value={formData.societyConsultas.bank}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyConsultas: {
                                ...formData.societyConsultas,
                                bank: e.target.value,
                              },
                            })
                          }
                        >
                          <option value=''>Seleccione banco</option>
                          {mockBanks.map((bank) => (
                            <option key={bank.id} value={bank.id}>
                              {bank.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Número de Cuenta</label>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Ingrese número de cuenta para Consultas'
                          value={formData.societyConsultas.accountNumber}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyConsultas: {
                                ...formData.societyConsultas,
                                accountNumber: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Email Sociedad</label>
                        <input
                          type='email'
                          className='form-control'
                          placeholder='Ingrese email de la sociedad'
                          value={formData.societyConsultas.email}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              societyConsultas: {
                                ...formData.societyConsultas,
                                email: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )
      case STEP_DOCUMENTACION:
        return (
          <div>
            <div className='card mb-5 mt-5' style={{border: '1px solid #e1e3ea'}}>
              <div
                className='card-header'
                style={{paddingInline: 10, paddingBlock: 0, minHeight: '40px'}}
              >
                <h5 className='card-title mb-0'>Documentación de Identidad</h5>
              </div>
              <div className='card-body' style={{paddingInline: '10px', paddingBlock: '10px'}}>
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <label className='form-label'>Cédula de Identidad (Frontal)</label>
                    <input
                      type='file'
                      className='form-control'
                      accept='.jpg,.jpeg,.png,.gif'
                      onChange={(e) => {
                        const file = e.target.files?.[0] || null
                        setFormData((prev) => ({
                          ...prev,
                          documents: {
                            ...prev.documents,
                            idFront: file,
                          },
                        }))
                      }}
                    />
                  </div>

                  <div className='col-md-6 mb-3'>
                    <label className='form-label'>Cédula de Identidad (Reverso)</label>
                    <input
                      type='file'
                      accept='.jpg,.jpeg,.png,.gif'
                      className='form-control'
                      onChange={(e) => {
                        const file = e.target.files?.[0] || null
                        setFormData((prev) => ({
                          ...prev,
                          documents: {
                            ...prev.documents,
                            idBack: file,
                          },
                        }))
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            {formData.hmqPaymentType === 'sociedad' &&
            formData.consultaPaymentType === 'sociedad' &&
            formData.societyHmq.rut === formData.societyConsultas.rut ? (
              <div className='card mb-5 mt-5' style={{border: '1px solid #e1e3ea'}}>
                <div
                  className='card-header'
                  style={{paddingInline: 10, paddingBlock: 0, minHeight: '40px'}}
                >
                  <h5 className='card-title mb-0'>
                    Documentación para {formData?.societyHmq?.name}
                  </h5>
                </div>
                <div className='card-body' style={{paddingInline: '10px', paddingBlock: '10px'}}>
                  <div className='row'>
                    <div className='col-md-6 mb-3'>
                      <label className='form-label'>Escritura Pública</label>
                      <input
                        type='file'
                        accept='.pdf,.doc,.docx,.jpg,.jpeg,.png,.gif'
                        className='form-control'
                        onChange={(e) => {
                          const file = e.target.files?.[0] || null
                          // Se guarda el archivo solo en societyDocsHmq (no es necesario duplicarlo)
                          setFormData((prev) => ({
                            ...prev,
                            documents: {
                              ...prev.documents,
                              societyDocsHmq: file,
                            },
                          }))
                        }}
                      />
                    </div>
                    <div className='col-md-6 mb-3'>
                      <label className='form-label'>¿Es usted el representante legal?</label>
                      <select
                        className='form-select'
                        value={formData.societyHmq.isLegalRepresentative}
                        onChange={(e) => {
                          const value = e.target.value
                          // Actualizamos ambos objetos para que tengan la misma información
                          setFormData({
                            ...formData,
                            societyHmq: {...formData.societyHmq, isLegalRepresentative: value},
                            societyConsultas: {
                              ...formData.societyConsultas,
                              isLegalRepresentative: value,
                            },
                          })
                        }}
                      >
                        <option value=''>Seleccione</option>
                        <option value='true'>Sí</option>
                        <option value='false'>No</option>
                      </select>
                    </div>
                  </div>

                  {formData.societyHmq.isLegalRepresentative === 'false' && (
                    <div className='card bg-light mb-3'>
                      <div className='card-body'>
                        <h5 className='card-title'>Datos del Representante Legal</h5>
                        <div className='row'>
                          <div className='col-md-6 mb-3'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='RUT del representante'
                              value={formData.societyHmq.representative.rut}
                              onChange={(e) => {
                                const formattedRut = formatRut(e.target.value)
                                // Se actualiza el RUT en ambos objetos
                                setFormData({
                                  ...formData,
                                  societyHmq: {
                                    ...formData.societyHmq,
                                    representative: {
                                      ...formData.societyHmq.representative,
                                      rut: formattedRut,
                                    },
                                  },
                                  societyConsultas: {
                                    ...formData.societyConsultas,
                                    representative: {
                                      ...formData.societyConsultas.representative,
                                      rut: formattedRut,
                                    },
                                  },
                                })
                              }}
                            />
                          </div>
                          <div className='col-md-6 mb-3'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Nombre del representante'
                              value={formData.societyHmq.representative.name}
                              onChange={(e) => {
                                const value = e.target.value
                                setFormData({
                                  ...formData,
                                  societyHmq: {
                                    ...formData.societyHmq,
                                    representative: {
                                      ...formData.societyHmq.representative,
                                      name: value,
                                    },
                                  },
                                  societyConsultas: {
                                    ...formData.societyConsultas,
                                    representative: {
                                      ...formData.societyConsultas.representative,
                                      name: value,
                                    },
                                  },
                                })
                              }}
                            />
                          </div>
                          <div className='col-md-6 mb-3'>
                            <input
                              type='email'
                              className='form-control'
                              placeholder='Email del representante'
                              value={formData.societyHmq.representative.email}
                              onChange={(e) => {
                                const value = e.target.value
                                setFormData({
                                  ...formData,
                                  societyHmq: {
                                    ...formData.societyHmq,
                                    representative: {
                                      ...formData.societyHmq.representative,
                                      email: value,
                                    },
                                  },
                                  societyConsultas: {
                                    ...formData.societyConsultas,
                                    representative: {
                                      ...formData.societyConsultas.representative,
                                      email: value,
                                    },
                                  },
                                })
                              }}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <input
                              type="tel"
                              className="form-control"
                              placeholder="Teléfono del representante"
                              value={formData.societyHmq.representative.phone}
                              onChange={(e) => {
                                const value = e.target.value;
                                setFormData({
                                  ...formData,
                                  societyHmq: {
                                    ...formData.societyHmq,
                                    representative: { ...formData.societyHmq.representative, phone: value }
                                  },
                                  societyConsultas: {
                                    ...formData.societyConsultas,
                                    representative: { ...formData.societyConsultas.representative, phone: value }
                                  }
                                });
                              }}
                            />
                          </div>
                          <div className='col-md-6 mb-3'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Nacionalidad del representante'
                              value={formData.societyHmq.representative.nacionalidad}
                              onChange={(e) => {
                                const value = e.target.value
                                setFormData({
                                  ...formData,
                                  societyHmq: {
                                    ...formData.societyHmq,
                                    representative: {
                                      ...formData.societyHmq.representative,
                                      nacionalidad: value,
                                    },
                                  },
                                  societyConsultas: {
                                    ...formData.societyConsultas,
                                    representative: {
                                      ...formData.societyConsultas.representative,
                                      nacionalidad: value,
                                    },
                                  },
                                })
                              }}
                            />
                          </div>
                          <div className='col-md-6 mb-3'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Comuna del representante'
                              value={formData.societyHmq.representative.comuna}
                              onChange={(e) => {
                                const value = e.target.value
                                setFormData({
                                  ...formData,
                                  societyHmq: {
                                    ...formData.societyHmq,
                                    representative: {
                                      ...formData.societyHmq.representative,
                                      comuna: value,
                                    },
                                  },
                                  societyConsultas: {
                                    ...formData.societyConsultas,
                                    representative: {
                                      ...formData.societyConsultas.representative,
                                      comuna: value,
                                    },
                                  },
                                })
                              }}
                            />
                          </div>
                          <div className='col-md-6 mb-3'>
                            <select
                              className='form-select'
                              value={formData.societyHmq.representative.region}
                              onChange={(e) => {
                                const value = e.target.value
                                setFormData({
                                  ...formData,
                                  societyHmq: {
                                    ...formData.societyHmq,
                                    representative: {
                                      ...formData.societyHmq.representative,
                                      region: value,
                                    },
                                  },
                                  societyConsultas: {
                                    ...formData.societyConsultas,
                                    representative: {
                                      ...formData.societyConsultas.representative,
                                      region: value,
                                    },
                                  },
                                })
                              }}
                            >
                              <option value=''>Seleccione una región</option>
                              {regiones.map((region) => (
                                <option key={region.id} value={region.id}>
                                  {region.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className='col-md-6 mb-3'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Dirección del representante'
                              value={formData.societyHmq.representative.direccion}
                              onChange={(e) => {
                                const value = e.target.value
                                setFormData({
                                  ...formData,
                                  societyHmq: {
                                    ...formData.societyHmq,
                                    representative: {
                                      ...formData.societyHmq.representative,
                                      direccion: value,
                                    },
                                  },
                                  societyConsultas: {
                                    ...formData.societyConsultas,
                                    representative: {
                                      ...formData.societyConsultas.representative,
                                      direccion: value,
                                    },
                                  },
                                })
                              }}
                            />
                          </div>
                          <div className='col-md-6 mb-3'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Profesión del representante'
                              value={formData.societyHmq.representative.profesion}
                              onChange={(e) => {
                                const value = e.target.value
                                setFormData({
                                  ...formData,
                                  societyHmq: {
                                    ...formData.societyHmq,
                                    representative: {
                                      ...formData.societyHmq.representative,
                                      profesion: value,
                                    },
                                  },
                                  societyConsultas: {
                                    ...formData.societyConsultas,
                                    representative: {
                                      ...formData.societyConsultas.representative,
                                      profesion: value,
                                    },
                                  },
                                })
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <>
                {formData.hmqPaymentType === 'sociedad' && (
                  <div className='card mb-5 mt-5' style={{border: '1px solid #e1e3ea'}}>
                    <div
                      className='card-header'
                      style={{paddingInline: 10, paddingBlock: 0, minHeight: '40px'}}
                    >
                      <h5 className='card-title mb-0'>
                        Documentación para {formData?.societyHmq?.name}
                      </h5>
                    </div>
                    <div
                      className='card-body'
                      style={{paddingInline: '10px', paddingBlock: '10px'}}
                    >
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <label className='form-label'>Escritura Pública</label>
                          <input
                            type='file'
                            accept='.pdf,.doc,.docx,.jpg,.jpeg,.png,.gif'
                            className='form-control'
                            onChange={(e) => {
                              const file = e.target.files?.[0] || null
                              setFormData((prev) => ({
                                ...prev,
                                documents: {
                                  ...prev.documents,
                                  societyDocsHmq: file,
                                },
                              }))
                            }}
                          />
                        </div>

                        <div className='col-md-6 mb-3'>
                          <label className='form-label'>¿Es usted el representante legal?</label>
                          <select
                            className='form-select'
                            value={formData.societyHmq.isLegalRepresentative}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                societyHmq: {
                                  ...formData.societyHmq,
                                  isLegalRepresentative: e.target.value,
                                },
                              })
                            }
                          >
                            <option value=''>Seleccione</option>
                            <option value='true'>Sí</option>
                            <option value='false'>No</option>
                          </select>
                        </div>
                      </div>

                      {formData.societyHmq.isLegalRepresentative === 'false' && (
                        <div className='card bg-light mb-3'>
                          <div className='card-body'>
                            <h5 className='card-title'>Datos del Representante Legal</h5>
                            <div className='row'>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='RUT del representante'
                                  value={formData.societyHmq.representative.rut}
                                  onChange={(e) => {
                                    const formattedRut = formatRut(e.target.value)
                                    setFormData({
                                      ...formData,
                                      societyHmq: {
                                        ...formData.societyHmq,
                                        representative: {
                                          ...formData.societyHmq.representative,
                                          rut: formattedRut,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Nombre del representante'
                                  value={formData.societyHmq.representative.name}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      societyHmq: {
                                        ...formData.societyHmq,
                                        representative: {
                                          ...formData.societyHmq.representative,
                                          name: e.target.value,
                                        },
                                      },
                                    })
                                  }
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='email'
                                  className='form-control'
                                  placeholder='Email del representante'
                                  value={formData.societyHmq.representative.email}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      societyHmq: {
                                        ...formData.societyHmq,
                                        representative: {
                                          ...formData.societyHmq.representative,
                                          email: e.target.value,
                                        },
                                      },
                                    })
                                  }
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='tel'
                                  className='form-control'
                                  placeholder='Teléfono del representante'
                                  value={formData.societyHmq.representative.phone}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      societyHmq: {
                                        ...formData.societyHmq,
                                        representative: {
                                          ...formData.societyHmq.representative,
                                          phone: e.target.value,
                                        },
                                      },
                                    })
                                  }
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Nacionalidad del representante'
                                  value={formData.societyHmq.representative.nacionalidad}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyHmq: {
                                        ...formData.societyHmq,
                                        representative: {
                                          ...formData.societyHmq.representative,
                                          nacionalidad: value,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Comuna del representante'
                                  value={formData.societyHmq.representative.comuna}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyHmq: {
                                        ...formData.societyHmq,
                                        representative: {
                                          ...formData.societyHmq.representative,
                                          comuna: value,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <select
                                  className='form-select'
                                  value={formData.societyHmq.representative.region}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyHmq: {
                                        ...formData.societyHmq,
                                        representative: {
                                          ...formData.societyHmq.representative,
                                          region: value,
                                        },
                                      },
                                    })
                                  }}
                                >
                                  <option value=''>Seleccione una región</option>
                                  {regiones.map((region) => (
                                    <option key={region.id} value={region.id}>
                                      {region.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Dirección del representante'
                                  value={formData.societyHmq.representative.direccion}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyHmq: {
                                        ...formData.societyHmq,
                                        representative: {
                                          ...formData.societyHmq.representative,
                                          direccion: value,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Profesión del representante'
                                  value={formData.societyHmq.representative.profesion}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyHmq: {
                                        ...formData.societyHmq,
                                        representative: {
                                          ...formData.societyHmq.representative,
                                          profesion: value,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {formData.consultaPaymentType === 'sociedad' && (
                  <div className='card mb-5 mt-5' style={{border: '1px solid #e1e3ea'}}>
                    <div
                      className='card-header'
                      style={{paddingInline: 10, paddingBlock: 0, minHeight: '40px'}}
                    >
                      <h5 className='card-title mb-0'>
                        Documentación para {formData?.societyConsultas?.name}
                      </h5>
                    </div>
                    <div
                      className='card-body'
                      style={{paddingInline: '10px', paddingBlock: '10px'}}
                    >
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <label className='form-label'>Escritura Pública</label>
                          <input
                            type='file'
                            accept='.pdf,.doc,.docx,.jpg,.jpeg,.png,.gif'
                            className='form-control'
                            onChange={(e) => {
                              const file = e.target.files?.[0] || null
                              setFormData((prev) => ({
                                ...prev,
                                documents: {
                                  ...prev.documents,
                                  societyDocsConsultas: file,
                                },
                              }))
                            }}
                          />
                        </div>
                        <div className='col-md-6 mb-3'>
                          <label className='form-label'>¿Es usted el representante legal?</label>
                          <select
                            className='form-select'
                            value={formData.societyConsultas.isLegalRepresentative}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                societyConsultas: {
                                  ...formData.societyConsultas,
                                  isLegalRepresentative: e.target.value,
                                },
                              })
                            }
                          >
                            <option value=''>Seleccione</option>
                            <option value='true'>Sí</option>
                            <option value='false'>No</option>
                          </select>
                        </div>
                      </div>
                      {formData.societyConsultas.isLegalRepresentative === 'false' && (
                        <div className='card bg-light mb-3'>
                          <div className='card-body'>
                            <h5 className='card-title'>Datos del Representante Legal</h5>
                            <div className='row'>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='RUT del representante'
                                  value={formData.societyConsultas.representative.rut}
                                  onChange={(e) => {
                                    const formattedRut = formatRut(e.target.value)
                                    setFormData({
                                      ...formData,
                                      societyConsultas: {
                                        ...formData.societyConsultas,
                                        representative: {
                                          ...formData.societyConsultas.representative,
                                          rut: formattedRut,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Nombre del representante'
                                  value={formData.societyConsultas.representative.name}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      societyConsultas: {
                                        ...formData.societyConsultas,
                                        representative: {
                                          ...formData.societyConsultas.representative,
                                          name: e.target.value,
                                        },
                                      },
                                    })
                                  }
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='email'
                                  className='form-control'
                                  placeholder='Email del representante'
                                  value={formData.societyConsultas.representative.email}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      societyConsultas: {
                                        ...formData.societyConsultas,
                                        representative: {
                                          ...formData.societyConsultas.representative,
                                          email: e.target.value,
                                        },
                                      },
                                    })
                                  }
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='tel'
                                  className='form-control'
                                  placeholder='Teléfono del representante'
                                  value={formData.societyConsultas.representative.phone}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      societyConsultas: {
                                        ...formData.societyConsultas,
                                        representative: {
                                          ...formData.societyConsultas.representative,
                                          phone: e.target.value,
                                        },
                                      },
                                    })
                                  }
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Nacionalidad del representante'
                                  value={formData.societyConsultas.representative.nacionalidad}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyConsultas: {
                                        ...formData.societyConsultas,
                                        representative: {
                                          ...formData.societyConsultas.representative,
                                          nacionalidad: value,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Comuna del representante'
                                  value={formData.societyConsultas.representative.comuna}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyConsultas: {
                                        ...formData.societyConsultas,
                                        representative: {
                                          ...formData.societyConsultas.representative,
                                          comuna: value,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <select
                                  className='form-select'
                                  value={formData.societyConsultas.representative.region}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyConsultas: {
                                        ...formData.societyConsultas,
                                        representative: {
                                          ...formData.societyConsultas.representative,
                                          region: value,
                                        },
                                      },
                                    })
                                  }}
                                >
                                  <option value=''>Seleccione una región</option>
                                  {regiones.map((region) => (
                                    <option key={region.id} value={region.id}>
                                      {region.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Dirección del representante'
                                  value={formData.societyConsultas.representative.direccion}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyConsultas: {
                                        ...formData.societyConsultas,
                                        representative: {
                                          ...formData.societyConsultas.representative,
                                          direccion: value,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                              <div className='col-md-6 mb-3'>
                                <input
                                  type='text'
                                  className='form-control'
                                  placeholder='Profesión del representante'
                                  value={formData.societyConsultas.representative.profesion}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({
                                      ...formData,
                                      societyConsultas: {
                                        ...formData.societyConsultas,
                                        representative: {
                                          ...formData.societyConsultas.representative,
                                          profesion: value,
                                        },
                                      },
                                    })
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )
      case STEP_FINAL:
        return (
          <div>
            <div className='alert alert-success'>
              <h4 className='alert-heading'>¡Solicitud Enviada!</h4>
              <p>
                Su solicitud ha sido recibida correctamente. En los próximos días recibirá un correo
                con:
              </p>
              <ul className='mb-0'>
                <li>La respuesta a su solicitud</li>
                <li>Un borrador del contrato para su revisión</li>
              </ul>
            </div>
          </div>
        )

      default:
        return null
    }
  }

  useEffect(() => {
    _getBanks()
    _getCiudades()
    _getComunas()
    _getRegiones()
  }, [])

  return (
    <div className='container py-5'>
      <div className='card'>
        <div className='card-body'>
          {error && <div className='alert alert-danger'>{error}</div>}

          {!requestType ? (
            <div className='row g-4'>
              <div className='col-md-6'>
                <div
                  className='card h-100 text-center'
                  style={{cursor: 'pointer', border: 'solid 1px #d2d2d2'}}
                  onClick={() => setRequestType('new')}
                >
                  <div className='card-body'>
                    <h5 className='card-title'>Nueva Solicitud</h5>
                    <p className='card-text'>Crear una nueva solicitud de contrato</p>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div
                  className='card h-100 text-center'
                  style={{cursor: 'pointer', border: 'solid 1px #d2d2d2'}}
                  onClick={() => setRequestType('search')}
                >
                  <div className='card-body'>
                    <h5 className='card-title'>Consultar Solicitud</h5>
                    <p className='card-text'>Ver el estado de solicitudes existentes</p>
                  </div>
                </div>
              </div>
            </div>
          ) : requestType === 'new' ? (
            <>
              <div className='mb-4'>
                <div className='progress' style={{height: '3px'}}>
                  <div
                    className='progress-bar'
                    role='progressbar'
                    style={{width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`}}
                  />
                </div>
                <div className='d-flex justify-content-between mt-2'>
                  {steps.map((step) => (
                    <div
                      key={step.id}
                      className={`text-center ${
                        currentStep >= step.id
                          ? 'text-primary'
                          : currentStep === step.id
                          ? 'text-primary'
                          : 'text-muted'
                      }`}
                      style={{width: `${100 / steps.length}%`}}
                    >
                      <div
                        className={`rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2 ${
                          currentStep > step.id
                            ? 'bg-primary text-white'
                            : currentStep === step.id
                            ? 'border border-primary'
                            : 'border'
                        }`}
                        style={{width: '32px', height: '32px'}}
                      >
                        {currentStep > step.id ? '✓' : step.id}
                      </div>
                      <small className='fw-medium'>{step.title}</small>
                      <small className='d-none d-md-block text-muted'>{step.description}</small>
                    </div>
                  ))}
                </div>
              </div>

              {renderStep()}
              <hr style={{border: 'solid 1px #d8d8d8'}} />

              <div className='d-flex justify-content-between mt-4'>
                <button
                  className='btn btn-light'
                  onClick={() => {
                    if (currentStep === 1) {
                      setRequestType('')
                      setError('')
                    } else {
                      setCurrentStep((prev) => prev - 1)
                    }
                  }}
                  disabled={loading || (currentStep === steps.length && steps.length > 2)}
                >
                  {currentStep === 1 ? 'Volver' : 'Anterior'}
                </button>

                {currentStep <= steps.length ? (
                  <button
                    className='btn btn-primary'
                    onClick={() => {
                      if (currentStep === STEP_VERIFICACION_RUT) {
                        validateRut(formData.rut)
                      } else if (currentStep === STEP_VALIDACION_DATOS) {
                        if (!showVerificationInput && selectedMethod) {
                          sendVerificationCode(selectedMethod)
                        } else if (showVerificationInput) {
                          verifyCode(selectedMethod, tempVerificationCode)
                        }
                      } else if (currentStep === steps.length - 1) {
                        finalizarSolicitud()
                      } else {
                        if (currentStep === STEP_FINAL) {
                          setRequestType('')
                          setCurrentStep(STEP_VERIFICACION_RUT)
                          setFormData(initialState)
                          setVerificationStatus({
                            email: false,
                            phone: false,
                          })
                          setSelectedMethod(null)
                          setShowVerificationInput(false)
                          setSteps(initialSteps)
                        } else {
                          setCurrentStep((prev) => prev + 1)
                        }
                      }
                    }}
                    disabled={!canProceed() || loading}
                  >
                    {loading ? (
                      <>
                        <span className='spinner-border spinner-border-sm me-2'></span>{' '}
                        Procesando...
                      </>
                    ) : currentStep === steps.length && steps.length > 2 ? (
                      'Finalizar '
                    ) : (
                      'Siguiente'
                    )}
                  </button>
                ) : (
                  <button
                    className='btn btn-success'
                    onClick={() => {
                      setRequestType('')
                      setCurrentStep(STEP_VERIFICACION_RUT)
                      setFormData(initialState)
                      setVerificationStatus({
                        email: false,
                        phone: false,
                      })
                      setSelectedMethod(null)
                      setShowVerificationInput(false)
                      setSteps(initialSteps)
                    }}
                  >
                    Volver al Inicio
                  </button>
                )}
              </div>
            </>
          ) : (
            renderConsultaView()
          )}
        </div>
      </div>
      <AlertDialog
        message={messageAlertError}
        show={showAlertError}
        success={true}
        onConfirm={() => {
          setShowAlertError(false)
        }}
      />
      <AlertDialog
        message={error}
        show={showError}
        success={false}
        onConfirm={() => {
          setShowError(false)
        }}
      />
    </div>
  )
}
